/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InventoryDocumentState {
    NEW = 'new',
    WAITING = 'waiting',
    ACCEPTED = 'accepted',
    CONFIRMED = 'confirmed',
    REJECTED = 'rejected',
    APPROVED = 'approved',
    RECEIVED = 'received',
    CANCELED = 'canceled',
    MODIFIED_AND_ACCEPTED = 'modifiedAndAccepted',
}
